import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import {getMessagemErro} from "../../utils/erro";
import { validaCamposNumericos } from "../../utils/formValidationUtil";
import api from "../../services/api";
import './Contract.css';
import { ContractDetails } from "./ContractDetails";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const APIContractDetailsEdit =

withRouter(

// redux
connect(
	(mapStateToProps),  
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				contrato: {},
				contratoApi: {
					idFornecedora: '',
					valorUnitarioConsultaAPI: '', 
					nivelServicoAcordado: ''
				},
				contratoApis: [],
				fornecedoras: [],
				exibeModalExcluir: false,
				botoesHabilitados: true,
				edicaoPermitida: false,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleInputNumberChange = this.handleInputNumberChange.bind(this);
			this.handleFornecedoraChange = this.handleFornecedoraChange.bind(this);
			this.carregarAPIsContrato = this.carregarAPIsContrato.bind(this);
			this.salvar = this.salvar.bind(this);
			this.editarContratoAPI = this.editarContratoAPI.bind(this);
			this.alterarContratoAPI = this.alterarContratoAPI.bind(this);
			this.excluirContratoAPI = this.excluirContratoAPI.bind(this);
			this.limpar = this.limpar.bind(this);

			this.confirmarExclusao = this.confirmarExclusao.bind(this);
			this.fecharModais = this.fecharModais.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Cadastro de Contrato - Informações de faturamento das API'S</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			const user = this.props.user;

			if(id){
				api.get('/api/contrato/' + id)
					.then(response => { 
						const contrato = response.data;
						const edicaoPermitida = (user.isAdministrador === true && contrato.contratoSerpro === false) || (user.isMantenedor === true  && contrato.contratoSerpro === true);

						this.setState(prevState => ({ ...prevState, contrato, edicaoPermitida,}))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar o contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}

			this.carregarAPIsContrato();

			api.get('/api/aplicacao-fornecedora/faturavel')
				.then(response => { 
					const fornecedoras = response.data;
					this.setState(prevState => ({ ...prevState, fornecedoras,}))
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as aplicações fornecedoras. " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
				
		}

		carregarAPIsContrato(){
			const id = this.props.match.params.id;
			if(id){
				api.get(`/api/contrato/${id}/contrato-apis`)
					.then(response => { 
						this.setState(prevState => ({ ...prevState, contratoApis: response.data }))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar as APIs do contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}
		}

		renderForm() {
			const numberFormater2 = new Intl.NumberFormat('pt-BR', {useGrouping: true, minimumFractionDigits:2, maximumFractionDigits:2 });
			const numberFormater7 = new Intl.NumberFormat('pt-BR', {useGrouping: true, minimumFractionDigits:7, maximumFractionDigits:7 });
			const { contrato, contratoApi, contratoApis, edicaoPermitida } = this.state;

			return(
				<div className="container-fluid">
					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalExcluir}
						handleOk={() => this.excluirContratoAPI()}
						handleCancel={() => this.fecharModais()}
						message="Deseja realmente remover as informações de faturamento da API?"/>

					<div className="br-form">
						<ContractDetails contrato={contrato} />

						{edicaoPermitida &&

							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>API:</label>
											<SelectSearch
												id="idFornecedora"
												name="idFornecedora"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												onChange={this.handleFornecedoraChange}
												value={contratoApi.idFornecedora}
												disabled={contratoApi.id}
											/>
										</div>
									</div>
								</div>
							</div>
						}

						{(edicaoPermitida && contratoApi.idFornecedora !== '') &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Nível de serviço acordado:</label>
											<NumberFormat value={contratoApi.nivelServicoAcordado} 
												thousandSeparator={'.'} 
												decimalSeparator={','} 
												decimalScale={2}
												allowNegative={false}
												isNumericString={true}
												className="texto-alinhado-direita"
												onValueChange={(valoresInput) => this.handleInputNumberChange('nivelServicoAcordado', valoresInput)}
												/>
										</div>
									</div>
								</div>
		
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Valor do unitário da consulta:</label>
											<NumberFormat value={contratoApi.valorUnitarioConsultaAPI} 
												thousandSeparator={'.'} 
												decimalSeparator={','} 
												decimalScale={7}
												allowNegative={false}
												isNumericString={true}
												prefix={'R$ '}
												className="texto-alinhado-direita"
												onValueChange={(valoresInput) => this.handleInputNumberChange('valorUnitarioConsultaAPI', valoresInput)}
												/>
										</div>
									</div>
								</div>
							</div>
						}


						<div className="actions-button">
							<div className="actions justify-content-start">
								{ edicaoPermitida &&
									<>
										{! contratoApi.id &&
											<button type="button" className="button is-primary" onClick={this.salvar} disabled={this.state.botoesHabilitados === false}>Incluir</button>
										}

										{contratoApi.id &&
											<button type="button" className="button is-primary" onClick={this.alterarContratoAPI} disabled={this.state.botoesHabilitados === false}>Alterar</button>
										}

										<button type="button" className="button is-secondary" onClick={this.limpar} disabled={this.state.botoesHabilitados === false}>Limpar</button>
									</>
								}

								{(contratoApis && contratoApis.length > 1) &&
									<Link to={`/contract/api-contract-group-edit/${contrato.id}`}> 
										<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Grupos de APIS's</button>
									</Link>
								}
								
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
						
						<fieldset>
							<legend>API's cadastradas</legend>
							{(contratoApis && contratoApis.length > 0) &&	
								<div className="br-table">						
									<div className="table">
										<table>
											<thead>
												<tr>
												<th scope="col">API</th>
												<th scope="col" className="text-right">Nível de Serviço Acordado</th>
												<th scope="col" className="text-right">Valor Unitário da Consulta</th>
												<th scope="col">Grupo</th>
												<th scope="col">Principal</th>
												{ edicaoPermitida &&
													<th className="text-center" scope="col">Ações</th>
												}
												</tr>
											</thead>
											
											<tbody>
												{ contratoApis.map((contratoApi, index) =>
														<tr key={index} >
															<td>{contratoApi.nomeFornecedora}</td>
															<td className="text-right">{numberFormater2.format(contratoApi.nivelServicoAcordado)}</td>
															<td className="text-right">{numberFormater7.format(contratoApi.valorUnitarioConsultaAPI)}</td>
															<td>{contratoApi.idGrupo ? contratoApi.nomeGrupo : ''}</td>
															<td>{contratoApi.idGrupo ? contratoApi.principal ? 'Sim' : 'Não' : ''}</td>
															{ edicaoPermitida &&
																<td className="text-center">
																	<div className="actions">
																		<button type="button" onClick={() => this.confirmarExclusao(contratoApi)} disabled={this.state.botoesHabilitados === false} title="Excluir API">
																			<span className="sr-only">Excluir</span>
																			<i className="fas fa-trash"></i>
																		</button>

																		<button type="button" onClick={() => this.editarContratoAPI(contratoApi)} disabled={this.state.botoesHabilitados === false} title="Editar API">
																			<span className="sr-only">Editar</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</div>
																</td>
															}
														</tr>
													)}
											</tbody>
										</table>
									</div>
								</div>
							}

							{(! contratoApis || contratoApis.length === 0) &&
								<div>
									Nenhuma API cadastrada no contrato.
								</div>
							}
						</fieldset>
					</div>

				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const contratoApi = this.state.contratoApi;
			contratoApi[nome] = valor;
			this.setState(prevState => ({ ...prevState, contratoApi }));
		}

		handleInputNumberChange(nomePropriedade, valoresInput){
			const contratoApi = this.state.contratoApi;
			contratoApi[nomePropriedade] = Number(valoresInput.value);
			this.setState(prevState => ({ ...prevState, contratoApi }));
		}

		handleFornecedoraChange(evento){
			this.props.limpaMensagem();
			const idFornecedora =  evento.target.value;
			const apiCadastradaContrato = this.getApiCadastradaContrato(idFornecedora);

			if (apiCadastradaContrato){
				this.editarContratoAPI(apiCadastradaContrato);
			}else{
				const contratoApi = {idFornecedora: '', valorUnitarioConsultaAPI: '', nivelServicoAcordado: ''};
				contratoApi['idFornecedora'] = idFornecedora;

				this.setState(prevState => ({ ...prevState, contratoApi }));
			}
		}

		getApiCadastradaContrato(idFornecedora){
			for(var contratoApi of this.state.contratoApis){
				if(contratoApi['idFornecedora'] === parseInt(idFornecedora)){
					return contratoApi;
				}
			}
			return;
		}
		
		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState(prevState => ({ ...prevState, botoesHabilitados: false }));
			const contratoApi = this.state.contratoApi;
			contratoApi['idContrato'] = this.state.contrato.id;
			const method = contratoApi.id ? 'put' : 'post';
			let url = `/api/contrato/contrato-api`;

			const options = {
				method,
				url,
				"data" : contratoApi,
			}
			this.props.mostraAguardando();

			api(options)
				.then(response => {
					const mensagem = `API ${contratoApi.id ? 'alterada' : 'incluída'} com sucesso!`;
					this.carregarAPIsContrato();
					this.setState(prevState => ({ ...prevState, contratoApi: {idFornecedora: '', valorUnitarioConsultaAPI: '', nivelServicoAcordado: ''}}))
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.contratoApi.id ? 'alterar' : 'incluir'} a API do contrato.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState(prevState => ({ ...prevState, botoesHabilitados: true }));
					this.props.escondeAguardando();
				});   

		}

		alterarContratoAPI(e){
			this.salvar(e);
			this.fecharModais();
		}

		editarContratoAPI(contratoApi){
			this.props.limpaMensagem();
			this.setState(prevState => ({ ...prevState, contratoApi: {...contratoApi}}));
			window.scrollTo(0, 0);
		}

		confirmarExclusao(contratoApi) {
			this.setState(prevState => ({ ...prevState, exibeModalExcluir: true, contratoApiAlvo: contratoApi, }));
		}

		fecharModais () {
			this.setState(prevState => ({ ...prevState, exibeModalExcluir:false,}));
		}

		excluirContratoAPI(){
			this.props.limpaMensagem();
			const contratoApi = this.state.contratoApiAlvo;
			let url = `/api/contrato/contrato-api/${contratoApi.id}`;
			const options = {
				method: 'delete',
				url,
				"data" : contratoApi,
			}
			this.props.mostraAguardando(); 
			this.setState(prevState => ({ ...prevState, botoesHabilitados:false}));

			api(options)
				.then(response => {
					const mensagem = `API excluída com sucesso!`;
					this.carregarAPIsContrato();
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir a API.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					
				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState(prevState => ({ ...prevState, botoesHabilitados:true}));
				});   
			
			this.fecharModais();
		}

		limpar(){
			this.props.limpaMensagem();
			this.setState(prevState => ({ ...prevState, contratoApi: {idFornecedora: '', valorUnitarioConsultaAPI: '', nivelServicoAcordado: ''},}))
		}

		validaFormulario(){
			const LIMITE_VALOR_UNITARIO_CONSULTA_API = 9999999999.99;
			let mensagens = [];
			const contratoApi = this.state.contratoApi;
			const {idFornecedora, valorUnitarioConsultaAPI, nivelServicoAcordado} = contratoApi
			if(idFornecedora === "" ){
				mensagens.push({mensagem: "API é obrigatório."})
			} else {
				validaCamposNumericos(mensagens, nivelServicoAcordado, "Nível de serviço acordado", true, false, false, 1);
				validaCamposNumericos(mensagens, valorUnitarioConsultaAPI, "Valor unitário da consulta", true, false, false, LIMITE_VALOR_UNITARIO_CONSULTA_API);
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

	}

) // redux
); // router